<a routerLink="/">
    <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
  </a>
<h1>Coaching Sessions</h1>
<img id="planet" src="../../assets/uninhabitedplanet.svg" alt="small planet">
<p>You can book a coaching session. During this coaching session, you get the opportunity to meet with and talk to one of our speakers. He or she will give you inspiration or a place to start to learn new things based on both your experience and interests and their experience and interests. This provides a unique experience and opportunity! </p>
<a appTicketRocket>
    <img src="../../assets/rockettickets.png" alt="buy tickets" class="tickets">
  </a>